export default __webpack_public_path__ + "static/media/sannan.efb5914e.jpg";